import type {ReactElement} from 'react'
import {Children} from 'react'

interface GridCardsProps {
	children: React.ReactNode
	className?: string
	col?: number
}

export const GridCards = ({
	children,
	className = '',
	col = 2,
}: GridCardsProps): ReactElement => {
	const columns: Record<number, string> = {
		1: 'md:w-full',
		2: 'md:w-1/2',
		3: 'md:w-1/2 lg:w-1/3',
		4: 'md:w-1/2 lg:w-1/3 xl:w-1/4',
		5: 'w-full md:w-1/2 lg:w-max', // unique classes for FactBlock story
	}

	const cardList = Children.map(children, (child) => {
		return (
			<div className={`${columns[col]} flex justify-center p-4`}>
				{child}
			</div>
		)
	})

	return (
		<div
			className={`flex-wrap md:flex ${className} m-auto justify-center md:max-w-[68rem] lg:max-w-[90rem]`}
		>
			{cardList}
		</div>
	)
}
